<template>
  <label
    class="flex items-center space-x-2 text-sm text-background-fg/87"
  >
    <span> Showing</span>
    <BaseSelect
      v-model="limit"
      :options="limitOptions"
      class="w-16 shrink-0"
    >
      <template #button>
        <button
          type="button"
          class="flex w-full items-center justify-between rounded-full border border-background-fg/8 bg-background px-3 py-1 text-xs font-medium text-background-fg/70 shadow-sm"
        >
          <span>{{ limit }}</span>
          <IconChevronDown
            class="rounded-full bg-background-fg/10"
          />
        </button>
      </template>
    </BaseSelect>
    <span> products</span>
  </label>
</template>

<script setup lang="ts">
const limit = defineModel<number>({ required: true })

const limitOptions = [5, 10, 15, 20, 50].map((value) => ({
  value,
  label: String(value),
}))
</script>
